import { render, staticRenderFns } from "./TemplatesListPage.vue?vue&type=template&id=ce9ea1e2"
import script from "./TemplatesListPage.vue?vue&type=script&lang=js"
export * from "./TemplatesListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports